import { render, staticRenderFns } from "./FeedbackCommentItem.vue?vue&type=template&id=893e09ba&scoped=true"
import script from "./FeedbackCommentItem.vue?vue&type=script&lang=ts"
export * from "./FeedbackCommentItem.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackCommentItem.vue?vue&type=style&index=0&id=893e09ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893e09ba",
  null
  
)

export default component.exports